import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { useI18n } from "../i18n";

export default function NotFound() {
    const { lang: urlLang } = useParams();
    const { lang } = useI18n();
    const l = urlLang || lang;
    return (
        <div className="mx-auto max-w-xl px-4 py-32 text-center">
            <div className="text-xs font-semibold uppercase tracking-[0.32em] text-ariovis-bordeaux">404</div>
            <h1 className="mt-4 font-display text-3xl font-semibold text-slate-950">
                {lang === "fr" ? "Page introuvable." : "Page not found."}
            </h1>
            <p className="mt-4 text-slate-700">
                {lang === "fr"
                    ? "Revenez à l'accueil pour construire votre feuille de route PAM."
                    : "Return home to build your PAM roadmap."}
            </p>
            <Button asChild className="mt-8 rounded-sm bg-ariovis-bordeaux text-white hover:bg-ariovis-fuschia">
                <Link to={`/${l}`}>{lang === "fr" ? "Retour à l'accueil" : "Back home"}</Link>
            </Button>
        </div>
    );
}
